<template>
  <div class="hello">
    <nav>
      <div class="container">
        <div class="block" style="display: inline-block">
          <el-date-picker v-model="value3" type="year" placeholder="请选择日期" style="width: 15.0rem"
            @change="rune()"></el-date-picker>
        </div>
        <div style="display: inline-block" @click="Contact1">
          <!-- <el-select
            clearable
            v-model="value"
            placeholder="请选择员工"
            @change="rune()"
          > -->
          <!-- <el-option
              v-for="item in optionss"
              :key="item.userid"
              :label="item.name"
              :value="item.userid"
            ></el-option>
          </el-select> -->
          <el-input v-model="addValue" placeholder="请选择员工"><i slot="suffix" v-if="this.addValue == ''"
              class="el-input__icon el-icon-arrow-down"></i><i slot="suffix" v-else class="el-input__icon el-icon-close"
              @click.stop="clears1"></i></el-input>
        </div>
        <div style="display: inline-block">
          <el-select clearable v-model="value1" placeholder="请选择类型" @change="rune()">
            <el-option v-for="item in optionn" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
        <span class="shij">
          <el-button @click="rune()" type="primary" icon="el-icon-search">查询</el-button>
        </span>
        <span class="shij">
          <el-button @click="onSubmit = true" type="primary" icon="el-icon-plus">添加</el-button>
        </span>
      </div>
    </nav>
    <el-table :data="tableData" v-loading="tableLoading" border  v-infinite-scroll="load">
      <el-table-column prop="type_name" label="名称" style="width: 10%"></el-table-column>
      <el-table-column prop="year" label="年" style="width: 10%"></el-table-column>
      <el-table-column prop="status" label="类型" style="width: 10%">
        <template slot-scope="scope">
          <div v-if="scope.row.status == 1">合同</div>
          <div v-if="scope.row.status == 2">回款</div>
        </template>
      </el-table-column>
      <el-table-column prop="yeartarget" label="年目标" style="width: 10%"></el-table-column>
      <el-table-column prop="january" label="一月" style="width: 10%"></el-table-column>
      <el-table-column prop="february" label="二月" style="width: 10%"></el-table-column>
      <el-table-column prop="march" label="三月" style="width: 10%"></el-table-column>
      <el-table-column prop="april" label="四月" style="width: 10%"></el-table-column>
      <el-table-column prop="may" label="五月" style="width: 10%"></el-table-column>
      <el-table-column prop="june" label="六月" style="width: 10%"></el-table-column>
      <el-table-column prop="july" label="七月" style="width: 10%"></el-table-column>
      <el-table-column prop="august" label="八月" style="width: 10%"></el-table-column>
      <el-table-column prop="september" label="九月" style="width: 10%"></el-table-column>
      <el-table-column prop="october" label="十月" style="width: 10%"></el-table-column>
      <el-table-column prop="november" label="十一月" style="width: 10%"></el-table-column>
      <el-table-column prop="december" label="十二月" style="width: 10%"></el-table-column>
      <el-table-column label="操作" fixed="right" width="80">
        <template slot-scope="scope">
          <el-button @click="
            (onSubmits = true),
            bianji(
              scope.row.id,
              scope.row.january,
              scope.row.february,
              scope.row.march,
              scope.row.april,
              scope.row.may,
              scope.row.june,
              scope.row.july,
              scope.row.august,
              scope.row.september,
              scope.row.october,
              scope.row.november,
              scope.row.december,
              scope.row.yeartarget
            )
          " type="text" size="mini">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div>
      <pagination :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" :page-sizes="[10, 20, 50, 100]"
        :auto-scroll="false" @pagination="userTable" />
    </div>
    <el-dialog title="添加" center :visible.sync="onSubmit" width="30%">
      <el-form ref="form" :model="form" label-width="8.0rem">
        <el-form-item label="年份" prop="name">
          <div class="block" style="display: inline-block">
            <el-date-picker v-model="form.year" type="year" placeholder="选择时间" style="width: 20.0rem"></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item label="员工" prop="name" style="height:4.0rem;">
          <div style="display: inline-block;width:20.0rem;" @click="Contact" class="yuan">
            <el-input :value="this.options"></el-input>

            <!--<div>{{ this.options }}</div>-->

            <i style="position:relative;top: -4.0rem;left: 17.5rem;color: #888;" class="el-icon-circle-close"
              v-show="disClear" @click.stop="clesroptions"></i>
          </div>
        </el-form-item>
        <el-form-item label="类型" prop="name">
          <el-select clearable v-model="form.status" placeholder="请选择">
            <el-option label="合同" value="1" style="height: auto">
            </el-option>
            <el-option label="回款" value="2" style="height: auto">
            </el-option>
          </el-select>
          <!--<el-radio-group v-model="form.status">
            <el-radio label="1">合同</el-radio>
            <el-radio label="2">目标</el-radio>
          </el-radio-group>--->
        </el-form-item>
        <el-form-item label="年目标" prop="name">
          <el-input clearable v-model="form.yeartarget" @change="fenkai()">
            <el-button slot="append">确定</el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="一月" prop="name">
          <el-input clearable v-model="form.january"></el-input>
        </el-form-item>
        <el-form-item label="二月" prop="name">
          <el-input clearable v-model="form.february"></el-input>
        </el-form-item>
        <el-form-item label="三月" prop="name">
          <el-input clearable v-model="form.march"></el-input>
        </el-form-item>
        <el-form-item label="四月" prop="name">
          <el-input clearable v-model="form.april"></el-input>
        </el-form-item>
        <el-form-item label="五月" prop="name">
          <el-input clearable v-model="form.may"></el-input>
        </el-form-item>
        <el-form-item label="六月" prop="name">
          <el-input clearable v-model="form.june"></el-input>
        </el-form-item>
        <el-form-item label="七月" prop="name">
          <el-input clearable v-model="form.july"></el-input>
        </el-form-item>
        <el-form-item label="八月" prop="name">
          <el-input clearable v-model="form.august"></el-input>
        </el-form-item>
        <el-form-item label="九月" prop="name">
          <el-input clearable v-model="form.september"></el-input>
        </el-form-item>
        <el-form-item label="十月" prop="name">
          <el-input clearable v-model="form.october"></el-input>
        </el-form-item>
        <el-form-item label="十一月" prop="name">
          <el-input clearable v-model="form.november"></el-input>
        </el-form-item>
        <el-form-item label="十二月" prop="name">
          <el-input clearable v-model="form.december"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onSubmit = false">取 消</el-button>
        <el-button type="primary" @click="numoo()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="修改" center :visible.sync="onSubmits" width="30%">
      <el-form :model="forms" label-width="8.0rem">
        <el-form-item label="年目标" prop="name">
          <el-input v-model="forms.yeartarget" @change="xfanke()">
            <el-button slot="append">确定</el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="一月" prop="name">
          <el-input v-model="forms.january"></el-input>
        </el-form-item>
        <el-form-item label="二月" prop="name">
          <el-input v-model="forms.february"></el-input>
        </el-form-item>
        <el-form-item label="三月" prop="name">
          <el-input v-model="forms.march"></el-input>
        </el-form-item>
        <el-form-item label="四月" prop="name">
          <el-input v-model="forms.april"></el-input>
        </el-form-item>
        <el-form-item label="五月" prop="name">
          <el-input v-model="forms.may"></el-input>
        </el-form-item>
        <el-form-item label="六月" prop="name">
          <el-input v-model="forms.june"></el-input>
        </el-form-item>
        <el-form-item label="七月" prop="name">
          <el-input v-model="forms.july"></el-input>
        </el-form-item>
        <el-form-item label="八月" prop="name">
          <el-input v-model="forms.august"></el-input>
        </el-form-item>
        <el-form-item label="九月" prop="name">
          <el-input v-model="forms.september"></el-input>
        </el-form-item>
        <el-form-item label="十月" prop="name">
          <el-input v-model="forms.october"></el-input>
        </el-form-item>
        <el-form-item label="十一月" prop="name">
          <el-input v-model="forms.november"></el-input>
        </el-form-item>
        <el-form-item label="十二月" prop="name">
          <el-input v-model="forms.december"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onSubmits = false">取 消</el-button>
        <el-button type="primary" @click="numsoo()">确 定</el-button>
      </span>
    </el-dialog>
    <right-people ref="dialog" :checkbox="checkbox" :selectionDepartment="selectionDepartment"
      @handleSelect="handleSelect"></right-people>
      <right-people ref="dialog1" :checkbox="checkbox" :selectionDepartment="selectionDepartment1"
      @handleSelect="handleSelect1"></right-people>
  </div>
</template>

<script>
import rightPeople from '@/components/drawer/rightPeople';
import axios from "axios";
import qs from "qs";
export default {
  inject: ["reload"],
  name: "department",
  components: {
    rightPeople,
  },
  data() {
    return {
      module: "",
      checkbox: false,
      selectionDepartment: true,
      selectionDepartment1: true,
      title: {},
      tooken: "",
      tableData: [],
      value3: "",
      onSubmit: false,
      onSubmits: false,
      form: {
        january: "", //1
        february: "", //2
        march: "", //3
        april: "", //4
        may: "", //5
        june: "", //6
        july: "", //7
        august: "", //8
        september: "", //9
        october: "", //10
        november: "", //11
        december: "", //12
        status: "1", //类型
        yeartarget: "", //年目标
        year: "", //年份
      },
      forms: {
        january: "", //1
        february: "", //2
        march: "", //3
        april: "", //4
        may: "", //5
        june: "", //6
        july: "", //7
        august: "", //8
        september: "", //9
        october: "", //10
        november: "", //11
        december: "", //12
        yeartarget: "", //年目标
        id: "",
      },
      optionss: [],
      value: "",
      optionn: [
        {
          value: "1",
          label: "合同",
        },
        {
          value: "2",
          label: "回款",
        },
      ],
      value1: "",
      options: "",
      id: "",
      yeshu: 1,
      abc: "",
      names: [],
      addValue: "",
      disClear: false,
      total: 0,
      listQuery: {
        page: 1,
        limit: 20,
      },
      tableLoading: true,
    };
  },
  watch: {
    value() {
      this.rune();
    },
  },
  updated() {
    if (this.options != "") {
      this.disClear = true;
    }
  },
  mounted() {
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
      // console.log(this.tooken);
    }
    this.userTable();

  },
  filters: {
    formatDate: function (value) {
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
    },
  },
  methods: {
    xfanke() {
      let a = this.forms.yeartarget / 12;
      a = a.toFixed(2);
      this.forms.january = a;
      this.forms.february = a;
      this.forms.march = a;
      this.forms.april = a;
      this.forms.may = a;
      this.forms.june = a;
      this.forms.july = a;
      this.forms.august = a;
      this.forms.september = a;
      this.forms.october = a;
      this.forms.november = a;
      this.forms.december = a;
    },
    fenkai() {
      let a;
      a = this.form.yeartarget / 12;
      a = a.toFixed(2);
      this.form.january = a;
      this.form.february = a;
      this.form.march = a;
      this.form.april = a;
      this.form.may = a;
      this.form.june = a;
      this.form.july = a;
      this.form.august = a;
      this.form.september = a;
      this.form.october = a;
      this.form.november = a;
      this.form.december = a;
    },
    clear() {
      this.optionss = '',
        this.value = ''
    },
    // 查询
    rune() {
      var b = new Date(this.value3).getFullYear();
      if (b !== 1970) {
        this.abc = b;
      } else if (b == 1970) {
        this.abc = "";
      }
      this.axios
        .post(
          "/crm/KpiSet/getKpiList",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            type: "3",
            type_id: this.value,
            year: this.abc,
            status: this.value1,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData = res.data.data;
        })
        .catch(function (err) { });
      this.axios
        .post(
          "/crm/KpiSet/getKpiUsers",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          // this.options = res.data.data;
          // this.optionss = res.data.data;
        })
        .catch(function (err) { });
    },
    Contact() {
      this.module = "getAddressBook";
      this.selectionDepartment = true;
      this.$refs.dialog.open();
    },
    Contact1() {
      this.module = "getAddressBook";
      this.selectionDepartment1 = true;
      this.$refs.dialog1.open();
    },
    handleSelect(person) {
      if (this.module == "getAddressBook") {
        // const userid = []
        // const user  =[]
        // person.map((item)=>{
        //   userid.push(item.userid)
        //   user.push(item.name)
        // })
        // this.id=userid.join()
        this.id = person.userid;
        this.options = person.name;
      }
    },
    handleSelect1(person) {
      if (this.module == "getAddressBook") {
        this.value = person.userid;
        this.addValue = person.name;
      }
    },
    // 编辑
    bianji(q, w, e, r, t, y, u, i, o, p, a, s, d, f) {
      this.forms.id = q;
      this.forms.january = w;
      this.forms.february = e;
      this.forms.march = r;
      this.forms.april = t;
      this.forms.may = y;
      this.forms.june = u;
      this.forms.july = i;
      this.forms.august = o;
      this.forms.september = p;
      this.forms.october = a;
      this.forms.november = s;
      this.forms.december = d;
      this.forms.yeartarget = f;
    },
    numsoo() {
      this.yeshu = 1;
      this.axios
        .post(
          "/crm/KpiSet/editKpiSet",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            // phone: this.tooken.phone,
            id: this.forms.id,
            january: this.forms.january, //1
            february: this.forms.february, //2
            march: this.forms.march, //3
            april: this.forms.april, //4
            may: this.forms.may, //5
            june: this.forms.june, //6
            july: this.forms.july, //7
            august: this.forms.august, //8
            september: this.forms.september, //9
            october: this.forms.october, //10
            november: this.forms.november, //11
            december: this.forms.december, //12
            yeartarget: this.forms.yeartarget, //年目标
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          if (res.data.code == 1) {
            this.onSubmits = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else if (res.data.code == 0) {
            this.onSubmits = true;
            this.$message.error(res.data.msg);
          }
          this.userTable();
        })
        .catch(function (err) { });
    },
    // 添加

    numoo() {
      var b = new Date(this.form.year).getFullYear();

      if (b !== 1970) {
        this.abc = b;
      } else if (b == 1970) {
        this.abc == "";
      }
      this.yeshu = 1;
      this.axios
        .post(
          "/crm/KpiSet/addKpiSet",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            type_id: this.id,
            type: "3",
            phone: this.tooken.phone,
            january: this.form.january, //1
            february: this.form.february, //2
            march: this.form.march, //3
            april: this.form.april, //4
            may: this.form.may, //5
            june: this.form.june, //6
            july: this.form.july, //7
            august: this.form.august, //8
            september: this.form.september, //9
            october: this.form.october, //10
            november: this.form.november, //11
            december: this.form.december, //12
            status: this.form.status, //类型
            yeartarget: this.form.yeartarget, //年目标
            year: b, //年份
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }

          if (res.data.code == 1) {
            this.reload();
            this.onSubmit = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else if (res.data.code == 0) {
            this.onSubmit = true;
            this.$message.error(res.data.msg);
          }
          this.userTable();
          // this.tableData = res.data.data;
        })
        .catch(function (err) {
          // console.log(err);
        });
    },
    // 页数
    load() { },
    userTable() {
      this.yeshu = 1;
      this.axios
        .post(
          "/crm/KpiSet/getKpiList",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            page: this.listQuery.page,
            number_page: this.listQuery.limit,
            type: "3",
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableLoading = false;
          this.tableData = res.data.data;
          this.total = res.data.count
        })
        .catch(function (err) { });
      this.axios
        .post(
          "/crm/KpiSet/getKpiUsers",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          // console.log(res);
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
        })
        .catch(function (err) { });
    },
    clears1() {
      this.addValue = "";
      this.value = "";
    },
    clesroptions() {
      this.disClear = false;
      this.options = ""
    },

  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='scss' scoped>
nav {
  margin: 2.0rem 0;
}

.container>div {
  margin-right: 2.0rem;
}

.container>span {
  margin-right: 2.0rem;
}

.yuan {
  width: 81%;
  height: 4.0rem;
  /*border: .1rem solid #dcdfe6;
  padding-left: 5%;*/
}

.yuan1 {
  border: .1rem solid #eeeeee;
  width: 18.0rem;
  height: 4.0rem;
  border-radius: .5rem;
  color: black;
  padding-left: .5rem;
  position: relative;
  top: 1.5rem;

  input {
    width: 100%;
    height: 100%;
    border: none;
    position: absolute;
  }
}

.btn {
  position: absolute;
  top: 34.5rem;
  left: 65.5rem;
  background: white;
  border: none;
  color: #eeeeee;
}
</style>
